import _regeneratorRuntime from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _marked = /*#__PURE__*/ _regeneratorRuntime().mark(syncExhibitionData), _marked2 = /*#__PURE__*/ _regeneratorRuntime().mark(getExhibitionData), _marked3 = /*#__PURE__*/ _regeneratorRuntime().mark(updateExhibitionData), _marked4 = /*#__PURE__*/ _regeneratorRuntime().mark(toggleLikeExhibitionButton), _marked5 = /*#__PURE__*/ _regeneratorRuntime().mark(getObjectData), _marked6 = /*#__PURE__*/ _regeneratorRuntime().mark(toggleLikeButton), _marked7 = /*#__PURE__*/ _regeneratorRuntime().mark(countView), _marked8 = /*#__PURE__*/ _regeneratorRuntime().mark(plusCurrentView), _marked9 = /*#__PURE__*/ _regeneratorRuntime().mark(watchSyncExhibitionData), _marked10 = /*#__PURE__*/ _regeneratorRuntime().mark(watchGetExhibitionData), _marked11 = /*#__PURE__*/ _regeneratorRuntime().mark(watchUpdateExhibitionData), _marked12 = /*#__PURE__*/ _regeneratorRuntime().mark(watchGetObjectData), _marked13 = /*#__PURE__*/ _regeneratorRuntime().mark(watchToggleLikeButton), _marked14 = /*#__PURE__*/ _regeneratorRuntime().mark(watchToggleLikeExhibitionButton), _marked15 = /*#__PURE__*/ _regeneratorRuntime().mark(watchCountView), _marked16 = /*#__PURE__*/ _regeneratorRuntime().mark(watchPlusCurrentView), _marked17 = /*#__PURE__*/ _regeneratorRuntime().mark(globalSaga);
import { all, fork, put, call, takeEvery, take, cancel } from "redux-saga/effects";
import { actions } from "../reducers/exhibition";
import { firestore, rsfDB } from "../lib/firebase"; // import { Notifier } from "../utils/notify/Notifier";
// import { sendNotifier } from "../utils/notify/NotifyPolicy";
// call은 동기, fork는 비동기 요청
function syncExhibitionData(action) { var id, task; return _regeneratorRuntime().wrap(function syncExhibitionData$(_context) { while (1)
    switch (_context.prev = _context.next) {
        case 0:
            id = action.id;
            _context.next = 3;
            return fork(rsfDB.syncDocument, "Exhibition/".concat(id), { successActionCreator: function successActionCreator(data) { console.log(data.data()); return { type: actions.SYNC_EXHIBITION_DATA_SUCCESS, id: data.id, data: _objectSpread(_objectSpread({}, data.data()), {}, { createdAt: data.data().createdAt ? data.data().createdAt.seconds * 1000 : null, updatedAt: data.data().updatedAt ? data.data().updatedAt.seconds * 1000 : null, publishedAt: data.data().publishedAt ? data.data().publishedAt.seconds * 1000 : null, paidAt: data.data().paidAt ? data.data().paidAt.seconds * 1000 : null, expiredAt: data.data().expiredAt ? data.data().expiredAt.seconds * 1000 : null }) }; }, failureActionCreator: function failureActionCreator(err) { return { type: actions.SYNC_EXHIBITION_DATA_FAILURE, err: err.message }; } });
        case 3:
            task = _context.sent;
            _context.next = 6;
            return take(actions.SYNC_EXHIBITION_DATA_DONE);
        case 6:
            _context.next = 8;
            return cancel(task);
        case 8:
        case "end": return _context.stop();
    } }, _marked); }
function getExhibitionData(action) { var id, snapshot; return _regeneratorRuntime().wrap(function getExhibitionData$(_context2) { while (1)
    switch (_context2.prev = _context2.next) {
        case 0:
            id = action.id;
            _context2.prev = 1;
            _context2.next = 4;
            return call(rsfDB.getDocument, "Exhibition/".concat(id));
        case 4:
            snapshot = _context2.sent;
            console.log(snapshot.data());
            _context2.next = 8;
            return put({ type: actions.GET_EXHIBITION_DATA_SUCCESS, id: snapshot.id, data: _objectSpread(_objectSpread({}, snapshot.data()), {}, { createdAt: snapshot.data().createdAt ? snapshot.data().createdAt.seconds * 1000 : null, updatedAt: snapshot.data().updatedAt ? snapshot.data().updatedAt.seconds * 1000 : null, publishedAt: snapshot.data().publishedAt ? snapshot.data().publishedAt.seconds * 1000 : null, paidAt: snapshot.data().paidAt ? snapshot.data().paidAt.seconds * 1000 : null, expiredAt: snapshot.data().expiredAt ? snapshot.data().expiredAt.seconds * 1000 : null }) });
        case 8:
            _context2.next = 14;
            break;
        case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            _context2.next = 14;
            return put({ type: actions.GET_EXHIBITION_DATA_FAILURE, error: _context2.t0.message });
        case 14:
        case "end": return _context2.stop();
    } }, _marked2, null, [[1, 10]]); }
function updateExhibitionData(action) { var id, target, value; return _regeneratorRuntime().wrap(function updateExhibitionData$(_context3) { while (1)
    switch (_context3.prev = _context3.next) {
        case 0:
            id = action.id, target = action.target, value = action.value;
            _context3.prev = 1;
            _context3.next = 4;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), target, value);
        case 4:
            _context3.next = 6;
            return put({ type: actions.UPDATE_EXHIBITION_DATA_SUCCESS });
        case 6:
            _context3.next = 12;
            break;
        case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            _context3.next = 12;
            return put({ type: actions.UPDATE_EXHIBITION_DATA_FAILURE, error: _context3.t0.message });
        case 12:
        case "end": return _context3.stop();
    } }, _marked3, null, [[1, 8]]); }
function toggleLikeExhibitionButton(action) { var id, ip; return _regeneratorRuntime().wrap(function toggleLikeExhibitionButton$(_context4) { while (1)
    switch (_context4.prev = _context4.next) {
        case 0:
            id = action.id, ip = action.ip;
            _context4.prev = 1;
            _context4.next = 4;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), "likedIPs", firestore.FieldValue.arrayUnion(ip));
        case 4:
            _context4.next = 6;
            return put({ type: actions.UPDATE_EXHIBITION_DATA_SUCCESS });
        case 6:
            _context4.next = 12;
            break;
        case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            _context4.next = 12;
            return put({ type: actions.UPDATE_EXHIBITION_DATA_FAILURE, error: _context4.t0.message });
        case 12:
        case "end": return _context4.stop();
    } }, _marked4, null, [[1, 8]]); }
function getObjectData(action) { var objectType, exhibitionId, id, snapshot; return _regeneratorRuntime().wrap(function getObjectData$(_context5) { while (1)
    switch (_context5.prev = _context5.next) {
        case 0:
            objectType = action.objectType, exhibitionId = action.exhibitionId, id = action.id;
            _context5.prev = 1;
            _context5.next = 4;
            return call(rsfDB.getDocument, "Exhibition/".concat(exhibitionId, "/").concat(objectType, "/").concat(id));
        case 4:
            snapshot = _context5.sent;
            _context5.next = 7;
            return put({ type: actions.GET_OBJECT_DATA_SUCCESS, data: snapshot.data(), id: id });
        case 7:
            _context5.next = 13;
            break;
        case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            _context5.next = 13;
            return put({ type: actions.GET_OBJECT_DATA_FAILURE, error: _context5.t0.message });
        case 13:
        case "end": return _context5.stop();
    } }, _marked5, null, [[1, 9]]); }
function toggleLikeButton(action) { var id, target, isLiked, ip, objectType; return _regeneratorRuntime().wrap(function toggleLikeButton$(_context6) { while (1)
    switch (_context6.prev = _context6.next) {
        case 0:
            id = action.id, target = action.target, isLiked = action.isLiked, ip = action.ip, objectType = action.objectType;
            _context6.prev = 1;
            _context6.next = 4;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id, "/").concat(objectType, "/").concat(target), { likedIPs: isLiked ? firestore.FieldValue.arrayRemove(ip) : firestore.FieldValue.arrayUnion(ip), likeCount: isLiked ? firestore.FieldValue.increment(-1) : firestore.FieldValue.increment(1) });
        case 4:
            _context6.next = 6;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), "objectLikeNum", isLiked ? firestore.FieldValue.increment(-1) : firestore.FieldValue.increment(1));
        case 6:
            _context6.next = 8;
            return put({ type: actions.TOGGLE_LIKE_BUTTON_SUCCESS });
        case 8:
            _context6.next = 14;
            break;
        case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](1);
            _context6.next = 14;
            return put({ type: actions.TOGGLE_LIKE_BUTTON_FAILURE, error: _context6.t0.message });
        case 14:
        case "end": return _context6.stop();
    } }, _marked6, null, [[1, 10]]); }
function countView(action) { var id, ip, exhibitionRef; return _regeneratorRuntime().wrap(function countView$(_context7) { while (1)
    switch (_context7.prev = _context7.next) {
        case 0:
            id = action.id, ip = action.ip;
            _context7.prev = 1;
            _context7.next = 4;
            return call(rsfDB.getDocument, "Exhibition/".concat(id));
        case 4:
            exhibitionRef = _context7.sent;
            _context7.next = 7;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), "todayVisitedIP", firestore.FieldValue.arrayUnion(ip));
        case 7:
            _context7.next = 9;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), "views.totalView", firestore.FieldValue.increment(1));
        case 9:
            _context7.next = 11;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), "views.todayView", firestore.FieldValue.increment(1));
        case 11:
            _context7.next = 13;
            return put({ type: actions.COUNT_VIEW_SUCCESS });
        case 13:
            _context7.next = 19;
            break;
        case 15:
            _context7.prev = 15;
            _context7.t0 = _context7["catch"](1);
            _context7.next = 19;
            return put({ type: actions.COUNT_VIEW_FAILURE, error: _context7.t0.message });
        case 19:
        case "end": return _context7.stop();
    } }, _marked7, null, [[1, 15]]); }
function plusCurrentView(action) { var id, randomKey; return _regeneratorRuntime().wrap(function plusCurrentView$(_context8) { while (1)
    switch (_context8.prev = _context8.next) {
        case 0:
            id = action.id, randomKey = action.randomKey;
            _context8.prev = 1;
            _context8.next = 4;
            return call(rsfDB.updateDocument, "Exhibition/".concat(id), "currentViews.".concat(randomKey), firestore.FieldValue.increment(1));
        case 4:
            _context8.next = 6;
            return put({ type: actions.PLUS_CURRENT_VIEW_SUCCESS });
        case 6:
            _context8.next = 12;
            break;
        case 8:
            _context8.prev = 8;
            _context8.t0 = _context8["catch"](1);
            _context8.next = 12;
            return put({ type: actions.PLUS_CURRENT_VIEW_FAILURE, error: _context8.t0.message });
        case 12:
        case "end": return _context8.stop();
    } }, _marked8, null, [[1, 8]]); }
function watchSyncExhibitionData() { return _regeneratorRuntime().wrap(function watchSyncExhibitionData$(_context9) { while (1)
    switch (_context9.prev = _context9.next) {
        case 0:
            _context9.next = 2;
            return takeEvery(actions.SYNC_EXHIBITION_DATA_REQUEST, syncExhibitionData);
        case 2:
        case "end": return _context9.stop();
    } }, _marked9); }
function watchGetExhibitionData() { return _regeneratorRuntime().wrap(function watchGetExhibitionData$(_context10) { while (1)
    switch (_context10.prev = _context10.next) {
        case 0:
            _context10.next = 2;
            return takeEvery(actions.GET_EXHIBITION_DATA_REQUEST, getExhibitionData);
        case 2:
        case "end": return _context10.stop();
    } }, _marked10); }
function watchUpdateExhibitionData() { return _regeneratorRuntime().wrap(function watchUpdateExhibitionData$(_context11) { while (1)
    switch (_context11.prev = _context11.next) {
        case 0:
            _context11.next = 2;
            return takeEvery(actions.UPDATE_EXHIBITION_DATA_REQUEST, updateExhibitionData);
        case 2:
        case "end": return _context11.stop();
    } }, _marked11); }
function watchGetObjectData() { return _regeneratorRuntime().wrap(function watchGetObjectData$(_context12) { while (1)
    switch (_context12.prev = _context12.next) {
        case 0:
            _context12.next = 2;
            return takeEvery(actions.GET_OBJECT_DATA_REQUEST, getObjectData);
        case 2:
        case "end": return _context12.stop();
    } }, _marked12); }
function watchToggleLikeButton() { return _regeneratorRuntime().wrap(function watchToggleLikeButton$(_context13) { while (1)
    switch (_context13.prev = _context13.next) {
        case 0:
            _context13.next = 2;
            return takeEvery(actions.TOGGLE_LIKE_BUTTON_REQUEST, toggleLikeButton);
        case 2:
        case "end": return _context13.stop();
    } }, _marked13); }
function watchToggleLikeExhibitionButton() { return _regeneratorRuntime().wrap(function watchToggleLikeExhibitionButton$(_context14) { while (1)
    switch (_context14.prev = _context14.next) {
        case 0:
            _context14.next = 2;
            return takeEvery(actions.TOGGLE_LIKE_EXHIBITION_BUTTON_REQUEST, toggleLikeExhibitionButton);
        case 2:
        case "end": return _context14.stop();
    } }, _marked14); }
function watchCountView() { return _regeneratorRuntime().wrap(function watchCountView$(_context15) { while (1)
    switch (_context15.prev = _context15.next) {
        case 0:
            _context15.next = 2;
            return takeEvery(actions.COUNT_VIEW_REQUEST, countView);
        case 2:
        case "end": return _context15.stop();
    } }, _marked15); }
function watchPlusCurrentView() { return _regeneratorRuntime().wrap(function watchPlusCurrentView$(_context16) { while (1)
    switch (_context16.prev = _context16.next) {
        case 0:
            _context16.next = 2;
            return takeEvery(actions.PLUS_CURRENT_VIEW_REQUEST, plusCurrentView);
        case 2:
        case "end": return _context16.stop();
    } }, _marked16); }
export default function globalSaga() { return _regeneratorRuntime().wrap(function globalSaga$(_context17) { while (1)
    switch (_context17.prev = _context17.next) {
        case 0:
            _context17.next = 2;
            return all([fork(watchSyncExhibitionData), fork(watchGetExhibitionData), fork(watchUpdateExhibitionData), fork(watchGetObjectData), fork(watchToggleLikeButton), fork(watchToggleLikeExhibitionButton), fork(watchCountView), fork(watchPlusCurrentView)]);
        case 2:
        case "end": return _context17.stop();
    } }, _marked17); }
